@if(isLoading) {
<kzn-loader [message]="'loaderGettingRequests' | translate"></kzn-loader>
} @else if(isError) {
<kzn-status-message [message]="errorMessage"></kzn-status-message>
} @else {
<div class="requests-page">
  <!-- My Request -->
  <div class="requests-page__header">
    <div class="requests-page__header-icon">
      <img src="assets/request_icon.png" alt="" class="requests-page__header-icon-img" />
    </div>
    <span class="requests-page__header-title">{{ 'myRequestSection' | translate }}</span>
  </div>

  <div class="requests-page__request-panel">
    <div class="requests-page__filter-bar">
      <div class="requests-page__filter-fields">
        <div class="requests-page__filter-item">
          <label class="requests-page__field-label">{{ 'requestDate' | translate }}</label>
          <mat-form-field appearance="outline" class="requests-page__filter-field requests-page__date-range-field">
            <mat-date-range-input [rangePicker]="reqRangePicker">
              <input
                matStartDate
                [placeholder]="'fromDate' | translate"
                [(ngModel)]="reqDateFrom"
                (dateChange)="onFilterFieldChange()" />
              <input
                matEndDate
                [placeholder]="'toDate' | translate"
                [(ngModel)]="reqDateTo"
                (dateChange)="onFilterFieldChange()" />
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="reqRangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #reqRangePicker></mat-date-range-picker>
          </mat-form-field>
        </div>

        <div class="requests-page__filter-item">
          <label class="requests-page__field-label">{{ 'completeDate' | translate }}</label>
          <mat-form-field appearance="outline" class="requests-page__filter-field requests-page__date-range-field">
            <mat-date-range-input [rangePicker]="completeRangePicker">
              <input
                matStartDate
                [placeholder]="'fromDate' | translate"
                [(ngModel)]="completeDateFrom"
                (dateChange)="onFilterFieldChange()" />
              <input
                matEndDate
                [placeholder]="'toDate' | translate"
                [(ngModel)]="completeDateTo"
                (dateChange)="onFilterFieldChange()" />
            </mat-date-range-input>
            @if (completeDateFrom || completeDateTo) {
            <button
              mat-icon-button
              matIconSuffix
              type="button"
              class="requests-page__btn-clear-complete"
              [matTooltip]="'clearCompleteDate' | translate"
              (click)="clearCompleteDateRange()">
              <mat-icon>cancel</mat-icon>
            </button>
            }
            <mat-datepicker-toggle matIconSuffix [for]="completeRangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #completeRangePicker></mat-date-range-picker>
          </mat-form-field>
        </div>

        <div class="requests-page__filter-item requests-page__filter-item--search">
          <input
            id="requests-search"
            type="text"
            class="requests-page__search-input"
            [placeholder]="'searchPlaceholder' | translate"
            [(ngModel)]="tableSearchQuery"
            (keyup)="onTableSearch()" />
        </div>
      </div>

      <div class="requests-page__filter-actions">
        <button
          mat-icon-button
          type="button"
          color="primary"
          class="requests-page__btn-refresh"
          [matTooltip]="'refreshTableTooltip' | translate"
          (click)="getAllRequests(true)">
          <mat-icon>refresh</mat-icon>
        </button>
        <button
          mat-icon-button
          type="button"
          color="primary"
          class="requests-page__btn-export"
          [disabled]="exportInProgress"
          [matTooltip]="'exportRequestsExcel' | translate"
          (click)="exportRequestsReport()">
          <span class="requests-page__export-icon-wrap" aria-hidden="true">
            <img class="requests-page__export-icon" src="assets/excel.jpg" alt="" />
          </span>
        </button>
        <!-- Clear hidden from UI — keep for future use
        <button
          mat-stroked-button
          type="button"
          class="requests-page__btn-clear"
          (click)="clearFilter()">
          {{ 'clear' | translate }}
        </button>
        -->
        <button
          mat-flat-button
          type="button"
          color="primary"
          class="requests-page__btn-apply"
          (click)="applyFilter()">
          {{ 'applyFilter' | translate }}
        </button>
      </div>
    </div>

    <div class="requests-page__stats-cards">
      @for (stat of statsCards; track stat.key) {
      <button
        type="button"
        class="requests-page__stat-card"
        [class.requests-page__stat-card--active]="activeChipStatus === stat.status"
        [class.requests-page__stat-card--open]="stat.key === 'open'"
        [class.requests-page__stat-card--signed]="stat.key === 'signed'"
        [class.requests-page__stat-card--cancelled]="stat.key === 'cancelled'"
        [class.requests-page__stat-card--declined]="stat.key === 'declined'"
        [class.requests-page__stat-card--all]="stat.key === 'all'"
        [style.background]="stat.bgColor"
        (click)="onStatCardClick(stat.status)">
        <span class="requests-page__stat-value" [style.color]="stat.color">{{ stat.value }}</span>
        <span class="requests-page__stat-label">{{ stat.labelKey | translate }}</span>
        <span class="requests-page__stat-sub" [style.color]="stat.color">{{ filterPeriodLabel }}</span>
      </button>
      }
    </div>

    @if (showChipFilterEmpty) {
    <div class="requests-page__chip-empty" role="status">
      {{
        'requestsChipNoStatusInCriteria'
          | translate: { status: (chipEmptyStatusLabelKey | translate) }
      }}
    </div>
    }

    <kzn-table
      #requestsTable
      [data]="tableRows"
      [columns]="tableColumns"
      style="width: 100%"
      [rowActions]="tableRowActions"
      [showRefresh]="false"
      [showSearch]="false"
      [showExpandedRows]="false"
      [defaultSortColumnDef]="'RequestDate'"
      [defaultSortDirection]="'desc'"
      [sortStorageKey]="requestsSortStorageKey"
      [sortStorageScope]="'session'"
      actionColumnHeader="actions"
    >
    </kzn-table>
  </div>
</div>
}
